export enum FilterType {
  EQUALS = 'EQUALS',
  NO_EQUALS = 'NO_EQUALS',
  MORE = 'MORE',
  LESS = 'LESS',
  MORE_OR_EQUALS = 'MORE_OR_EQUALS',
  LESS_OR_EQUALS = 'LESS_OR_EQUALS',
  CONTAINS = 'CONTAINS',
  NOT_CONTAINS = 'NOT_CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  IS_NULL = 'IS_NULL',
  IS_NOT_NULL = 'IS_NOT_NULL',
  IS_TRUE = 'IS_TRUE',
  IS_FALSE = 'IS_FALSE',
  LAST_MINUTES = 'LAST_MINUTES',
  LAST_HOURS = 'LAST_HOURS',
  LAST_DAYS = 'LAST_DAYS',
  LAST_WEEKS = 'LAST_WEEKS',
  OLDER_THAN_MINUTES = 'OLDER_THAN_MINUTES',
  OLDER_THAN_HOURS = 'OLDER_THAN_HOURS',
  OLDER_THAN_DAYS = 'OLDER_THAN_DAYS',
  OLDER_THAN_WEEKS = 'OLDER_THAN_WEEKS',
  RANGE = 'RANGE',
}